import styled from 'styled-components';
import IconNavigationSVG from "./icon-navigation-check.svg";

const IconNavigationCheck = styled(IconNavigationSVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.ash.base};
  cursor: pointer;
`;

export default IconNavigationCheck;
